import { getDataLocalObj, setDataLocal } from "./WebStorage/CoreWebStorage"

export const HTMLParse = (html) => {
  var parser = new DOMParser()
  const docHtml = parser.parseFromString(html, 'text/html')
  return docHtml
}

export const getData = (name) => {
  const data = sessionStorage.getItem(name)
  try {
    if (!data) {
    return []
  } else {
    return JSON.parse(data)
  }
  } catch (error) {
    return []
  }
}

export function decreaseFloatPrecission (strFloat, precission = 4) {
  const result = parseFloat(strFloat).toFixed(precission)
  return parseFloat(result)
}

export const setData = (name, payload) => {
    sessionStorage.setItem(name, JSON.stringify(payload))
}

export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (!userStr) return null;
  else return JSON.parse(userStr);
}

export const getAccessToken = () => {
  const token = localStorage.getItem('accesstoken');
  return token
}

export const getRefreshToken = () => {
  const token = localStorage.getItem('refreshtoken');
  return token
}

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.clear()
  localStorage.clear()
}

// set the token and user from the session storage
export const setUserSession = (accessToken, refreshToken, payload) => {
  console.log('Set User Sessions')
  console.log({ accessToken, refreshToken, payload })
  localStorage.setItem('accesstoken', accessToken);
  localStorage.setItem('refreshtoken', refreshToken);
  sessionStorage.setItem('user', JSON.stringify(payload));
}

export const refreshUserSession = (accessToken, refreshToken) => {
  localStorage.setItem('accesstoken', accessToken);
  localStorage.setItem('refreshtoken', refreshToken);
}

export const setAccessToken = (token) => {
  localStorage.setItem('accesstoken', token);
}

export const addDashboard = (payload) => {
 return setData('dashboard', payload)
}

export const getDashboard = () => {
 try {
   const data = getData('dashboard')
   if (!data.length) {
     return dashboardDefaultsData
   }

   return data
 } catch (error) {
   return dashboardDefaultsData
 }
}

export const addUserData = (payload) => {
  setDataLocal('userData', payload)
}

export const getUserData = () => {
  return getDataLocalObj('userData')
}

export const decodeToken = (accessToken) => {
  try {
    const base64Url = accessToken.split('.')[1];
    if (base64Url === undefined) return null;
    const decodedValue = JSON.parse(window.atob(base64Url));

    return decodedValue;
  } catch (error) {
    // console.log(error.message)
    return {
      id: '',
      name: '',
      email: ''
    }
  }
}

export function getThemeState () {
        try {
            return localStorage.getItem("isp-dark") === "1";
        } catch {
            return false;
        }
    }

const dashboardDefaultsData = {
    type: 'inv',
        currentPeriod: {
            type: 'inv',
            id: '',
            name: '',
            creation: '',
            modified: '',
        },
        paidPeriod: [
            {
                id: '',
                name: 'XXXXXXXXXXXX',
                is_va_sync: false,
                is_message_send: false,
                customerId: 'XXXXXXXXXXXX',
                customerName: '',
                creation: '',
                due: '',
                total: 0,
                mitra_name: '',
                startDate: '',
                periodStart: '',
                yearStart: 2026,
                endDate: '',
                periodEnd: '',
                yearEnd: 2026,
                paid: true,
                date: '',
                customerEmail: ''
            },
        ],
        date: '',
        customerId: 'XXXXXXXXXXXX',
        subs: [
            {
                id: 'XXXXXXXXXXXX',
                name: '',
                firstname: '',
                lastname: '',
                status: 'active'
            }
        ],
        psb: [],
        profile: {
            id: 'XXXXXXXXXXXX',
            name: '',
            username: '',
            fullName: '',
            enabled: true,
            organization: '',
            ppn: false,
            bniVa: 9881231000900000,
            briVa: null,
            mandiriVa: null,
            psbbniVa: 9881231025080000,
            enableFupSupport: false
        },
        serviceStatus: {
            state: 'unknown',
            label: 'Status layanan belum tersedia',
            checkedAt: '',
            outage: {
                active: false,
                summary: []
            },
            fup: {
                enabled: false,
                visible: false,
                shouldShowTopUp: false,
                baseQuota: 0,
                purchasedQuota: 0,
                effectiveQuota: 0,
                usedQuota: 0,
                remainingQuota: 0,
                remainingPercent: null,
                isThrottled: false,
                lastUsageAt: null
            }
        }
  }

export function registerNewPayloads (
    firstname,
    lastname,
    mitra,
    email,
    ktp,
    mobileNo,
    city,
    itemNotes,
    subDistrict,
    urban,
    category,
    addressLine,
    latitude,
    longitude) {
  return {
    firstname,
    lastname,
    mitra,
    email,
    ktp,
    mobileNo,
    city,
    itemNotes,
    subDistrict,
    urban,
    category,
    addressLine,
    latitude,
    longitude
  }
}
